/*
  Arquivo neutralizado para o editor da Shopify.
  A versão anterior criava um overlay de carregamento no modo de personalização,
  causando tela branca/spinner a cada poucos segundos.
*/
(function () {
  window._storefrontModuleInitDisabled = true;
})();
